import React from 'react';

//Redux
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actualizarEstadoAjuste } from '../../actions/controlCapacitacionesActions';

const withAjuste = WappedComponet => props  => {

  const { idCapacitacion } = useParams();
  const dispatch = useDispatch();

  const handleEstadoIndicador = (id, estado) => {
    dispatch( actualizarEstadoAjuste(idCapacitacion, estado, id ));
  }

  return ( 
    <WappedComponet
      {...props}
      handleEstadoIndicador={handleEstadoIndicador}
    />
   );
}
 
export default withAjuste;